import React from "react";

const WrongAudio = () => {
  return (
    <audio id="backgroundMusic" autoPlay>
      <source src="/audio/Wrong.mp3" type="audio/mp3" />
    </audio>
  );
};

export default WrongAudio;
